import { FC, Fragment, useEffect, useState } from 'react';
import { List } from '@mantine/core';
import { Button } from '@common/components';
import { ReportedItem } from './components';
import { useTranslation } from 'react-i18next';
import { IReportIssueProps } from '@common/types/types';

import styles from './styles.module.scss';
import { IReportedAdminIssue } from 'src/store';

interface ReportedSiteListProps {
  issues?: IReportIssueProps[];
  adminIssues?: IReportedAdminIssue[];
  userRole: string;
  nextToken?: string | null;
  onLoadMore?: () => void;
}

const ReportedSiteList: FC<ReportedSiteListProps> = ({ issues, nextToken, onLoadMore, userRole, adminIssues }) => {
  const [isShowMore, setIsShowMore] = useState(true);
  const [t] = useTranslation('reported');
  const handleShowMore = (): void => {
    onLoadMore && onLoadMore();
  };

  useEffect(() => {
    if (nextToken) {
      setIsShowMore(true);
    } else {
      setIsShowMore(false);
    }
  }, [nextToken]);

  return (
    <Fragment>
      <List w={'100%'} className={styles['list']}>
        {issues &&
          issues?.map((item) => (
            <div key={item.issueId}>
              <ReportedItem item={item} key={item.reportNumber} userRole={userRole} />
            </div>
          ))}
        {adminIssues &&
          adminIssues?.map((item) => (
            <div key={item.issue.issueId}>
              <ReportedItem item={item.issue} key={item.issue.reportNumber} userRole={userRole} />
            </div>
          ))}
      </List>
      {isShowMore && (
        <Button className={styles['load-more']} small onClick={handleShowMore}>
          {t('loadMoreButton')}
        </Button>
      )}
    </Fragment>
  );
};

export default ReportedSiteList;
